<template>
  <template-layout :customMenu="customMenu">
    <div class="pb-12 px-2 sm:px-4">
        <Breadcrumb :bread-crumb-list="breadcrumbComputed" class="mb-2" />
        <div class="w-1/6 h-1/6 mx-auto" v-if="loadingSurveyData">
            <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
        </div>
        <div class="grid grid-cols-2 gap-6" v-else>
            <div class="col-span-2">
                <div class="items-center mb-6">
                    <h1 class="text-lg font-medium mr-auto">
                    รายงานผลการตรวจสอบความถูกต้องของข้อมูลครัวเรือนและสมาชิกในครัวเรือน
                    </h1>
                </div>
                <div class="box rounded-md shadow-md p-5" v-if="householdData">
                    <div class="flex flex-col min-w-full md:min-w-0 md:flex-grow">
                        <span class="text-base font-normal text-theme-1 mb-1">
                            หัวหน้าครัวเรือน: {{ `${householdData.houseHeadName ? householdData.houseHeadName : "-"}` }}
                        </span>
                        <span class="text-base font-normal text-theme-1 mb-1"
                            >รหัสประจำบ้าน: 
                            {{ householdData.house_number_11 ? householdData.house_number_11 : "-" }}</span
                        >

                        <p class="text-base text-theme-1 font-normal">
                            ที่อยู่: {{ householdData.addressResult ? householdData.addressResult : "-" }}
                        </p>
                        <hr class="mt-3" />
                        <div class="rounded-xl overflow-hidden" v-if="resultError?.isPass">
                            <div class="p-2 pt-4">
                                <div class="flex items-center justify-center gap-3">
                                    <CheckCircleIcon class="h-10 w-10 text-theme-10" />
                                    <h3 class="text-lg font-bold text-theme-10">แบบประเมินผ่านการตรวจสอบ</h3>
                                </div>
                            </div>
                            <!-- <div class="p-6 pt-2" v-if="warningList.length">
                                <h4 class="text-base font-semibold text-yellow-600 mb-3">พบข้อสังเกต {{warningList.length}} รายการ</h4>
                                <ul class="text-left space-y-3">
                                    <li
                                        v-for="(warn, index) in warningList"
                                        :key="index"
                                        class="flex items-start gap-3 p-3 bg-yellow-50/50 rounded-lg border border-yellow-100"
                                        :class="canJumpToError(warn) ? 'cursor-pointer hover:bg-yellow-100/60 transition-colors' : ''"
                                        @click="canJumpToError(warn) ? jumpToError(warn) : null"
                                    >
                                        <span class="text-gray-700">{{index + 1}}. {{ warn.message }}</span>
                                        <ArrowRightIcon v-if="canJumpToError(warn)" class="h-4 w-4 text-yellow-600 ml-auto mt-1 flex-shrink-0" />
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                        <div class="rounded-xl overflow-hidden" v-else-if="resultError?.errors?.length">

                            <div class="p-2">
                                <div class="flex items-center gap-3">
                                    <InfoIcon class="h-10 w-10 text-theme-24" />
                                    <h3 class="text-lg font-bold text-theme-24">ไม่ผ่านการตรวจสอบ พบข้อผิดพลาด {{resultError.errors.length}} รายการ</h3>
                                </div>
                            </div>

                            <div class="p-6 pt-2">
                                <ul class="text-left space-y-3" >
                                    <li
                                        v-for="(err, index) in resultError.errors"
                                        :key="index"
                                        class="flex items-start gap-3 p-3 bg-red-50/50 rounded-lg border border-red-100"
                                        :class="canJumpToError(err) ? 'cursor-pointer hover:bg-red-100/60 transition-colors' : ''"
                                        @click="canJumpToError(err) ? jumpToError(err) : null"
                                    >
                                        <span class="text-gray-700">{{index + 1}}. {{ err.message }}</span>
                                        <ArrowRightIcon v-if="canJumpToError(err)" class="h-4 w-4 text-theme-24 ml-auto mt-1 flex-shrink-0" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="rounded-xl overflow-hidden" v-else>
                            
                            <div class="p-2 pt-4">
                                <div class="flex items-center justify-center gap-3">
                                    <XCircleIcon class="h-10 w-10 text-theme-24" />
                                    <h3 class="text-lg font-bold text-theme-24">การตรวจสอบผิดพลาด กรุณาลองใหม่อีกครั้ง</h3>
                                </div>
                            </div>
                        </div>
                        <div class="p-6 pt-0" v-if="warningList.length">
                            <h3 class="text-base font-semibold text-theme-22 mb-3">พบข้อสังเกต {{warningList.length}} รายการ</h3>
                            <ul class="text-left space-y-3">
                                <li
                                    v-for="(warn, index) in warningList"
                                    :key="index"
                                    class="flex items-start gap-3 p-3 bg-yellow-50/50 rounded-lg border border-yellow-100"
                                    :class="canJumpToError(warn) ? 'cursor-pointer hover:bg-yellow-100/60 transition-colors' : ''"
                                    @click="canJumpToError(warn) ? jumpToError(warn) : null"
                                >
                                    <span class="text-gray-700">{{index + 1}}. {{ warn.message }}</span>
                                    <ArrowRightIcon v-if="canJumpToError(warn)" class="h-4 w-4 text-yellow-600 ml-auto mt-1 flex-shrink-0" />
                                </li>
                            </ul>
                        </div>
                        <div class="bg-gray-50 p-5 border-t border-gray-100 flex justify-end gap-3" v-if="resultError?.errors?.length">
                            <button
                                class="btn btn-primary bg-primary-btn border-primary-btn mr-1 mb-2"
                                @click="router.push({ name: 'edit-household', params: {hhid: route.params.hhid, surveyid: route.params.surveyid}})"
                                :disabled="!getPermissionAccessMenu('update') && onlineComputed"
                            >
                                <Edit2Icon class="h-3 w-3 mr-2" />แก้ไข
                            </button>
                            <button
                                @click="exportExcelErrorList"
                                class="btn btn-primary bg-primary-btn border-primary-btn mr-1 mb-2"
                                :disabled="!getPermissionAccessMenu('update') && onlineComputed"
                            >
                                <DownloadIcon class="h-3 w-3 mr-2" />นำออก Excel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template-layout>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import TemplateLayout from "@/layouts/top-navbar-menu/Main.vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import axios from "axios";
import Swal from "sweetalert2";
import { validateSurveyData } from "@/utils/checkHouseholdSurvey";
import { getPermissionAccessMenu } from "@/utils/getPermission";
import { utils, writeFile } from "xlsx"
import Breadcrumb from "@/components/breadcrumb/index.vue"

const store = useStore()
const route = useRoute()
const router = useRouter()
const householdData = ref(null)
const customMenu = ref([])
const onlineComputed = computed(()=> store.getters["network/isOnline"])
const loadingSurveyData = ref(false)
const resultError = ref(null)
const warningList = computed(() => resultError.value?.warnings ?? [])

const canJumpToError = (err) => {
    return true
    // return householdData.value?.status === 'DRAFT'
    //     && getPermissionAccessMenu('update')
    //     && !!err?.step
}

const jumpToError = (err) => {
    if (!canJumpToError(err)) return
    if(err.step){
        router.push({
            name: 'edit-household',
            params: { id: route.params.hhid },
            query: {
                step: err.step,
                q: err.questionCode,
                from: 'verify'
            }
        })
    }
    else{
        router.push({
            name: err.questionCode,
            params: { hhid: route.params.hhid, surveyid: route.params.surveyid },
            query: { from: 'verify' }
        })
    }
}

const getSurvey = async () =>{
    const token = store.getters["userAuth/getToken"];
    const url = `${process.env.VUE_APP_BASE_API}house/${route.params.hhid}`;
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": `application/json; charset=utf-8`,
    };
    loadingSurveyData.value = !loadingSurveyData.value
    const res = await axios.get(url, { headers }).catch(() =>
        Swal.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        })
    );
    if (res.status === 200) {
        householdData.value = res.data
        loadingSurveyData.value = !loadingSurveyData.value
        if(householdData.value.house_surveys?.length){
            const idx = householdData.value.house_surveys.findIndex(x=>x._id == route.params.surveyid)
            householdData.value.member_cnt = householdData.value.house_surveys[idx].member_cnt ?? 0
            householdData.value.member_reg_cnt = householdData.value.house_surveys[idx].member_reg_cnt ?? 0
            householdData.value["addressResult"] = ""
            if (householdData.value.address_num)
                householdData.value["addressResult"] += householdData.value.address_num;
            if (householdData.value.village_name)
                householdData.value["addressResult"] += ` ${householdData.value.village_name}`;
            if (householdData.value.tambol_name)
                householdData.value["addressResult"] += ` ${
                    householdData.value.province_name !== "กรุงเทพมหานคร"
                    ? `ตำบล`
                    : `แขวง`
                }${householdData.value.tambol_name}`;
            if (householdData.value.amphur_name)
                householdData.value["addressResult"] += ` ${
                    householdData.value.province_name !== "กรุงเทพมหานคร"
                    ? `อำเภอ`
                    : `เขต`
                }${householdData.value.amphur_name}`;
            if (householdData.value.province_name)
                householdData.value["addressResult"] += ` จังหวัด${householdData.value.province_name}`;

            householdData.value.status = householdData.value.house_surveys[idx].status ?? null
            householdData.value["houseHeadName"] = householdData.value.house_surveys[idx].headOfHousehole_name ? `${householdData.value.house_surveys[idx].headOfHousehole_prefix_name} ${householdData.value.house_surveys[idx].headOfHousehole_name} ${householdData.value.house_surveys[idx].headOfHousehole_surname}` : null
            
            resultError.value = await validateSurveyData(householdData.value)
        }
    }
}

const exportExcelErrorList = () => {
    const errorList = resultError.value?.errors ?? []
    if(errorList.length > 0){
        const worksheetData = errorList.map((err, index) => ({
            "ลำดับ": index + 1,
            "ข้อความผิดพลาด": err.message
        }))
        const ws = utils.json_to_sheet(worksheetData)
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Error List");
        let date = new Date()
        let current_date = [date.getFullYear(),String(date.getMonth() + 1).padStart(2, '0'),String(date.getDate()).padStart(2, '0'),String(date.getHours()).padStart(2, '0'),String(date.getMinutes()).padStart(2, '0'),String(date.getSeconds()).padStart(2, '0')].join('')
        let file_name = `error_list_household_${current_date}`
        writeFile(wb, `${file_name}.xlsx`);
    }
}
const getCustomMenu = () => {
    if(householdData.value?.house_surveys?.length > 0){
        let sub_menu = []
        for(let i = householdData.value.house_surveys.length; i > 0; i-- ){
            sub_menu.push({
                icon: '',
                pageName: 'household-profile',
                title: `ครั้งที่ ${i}` ,
                params: {
                    hhid: householdData.value._id,
                    surveyid: householdData.value.house_surveys[i-1]["_id"]
                },
                path: `/household/${householdData.value._id}/${householdData.value.house_surveys[i-1]["_id"]}`
            })
        }
        customMenu.value = [
            {key: "devider"},
            {
                icon: "FileTextIcon",
                title: "แบบสำรวจ",
                subMenu: sub_menu
            }
        ]
        const idx = householdData.value.house_surveys.findIndex(x=>x._id == route.params.surveyid)
        const dataMember = householdData.value.house_surveys[idx]?.member_surveys ?? []
        if(dataMember.length > 0){
            let member_menu = []
            for(let i = 0; i < dataMember.length; i++ ){
                member_menu.push({
                    pageName: 'view-member',
                    title: `${dataMember[i].name} ${dataMember[i].surname}` ,
                    params: {
                        hhid: householdData.value._id,
                        surveyid: householdData.value.house_surveys[idx]._id,
                        memberid: dataMember[i].member_id
                    },
                    path: `/member/view/${householdData.value._id}/${householdData.value.house_surveys[idx]._id}/${dataMember[i].member_id}`,
                    image: dataMember[i]?.image?.img_url ? process.env.VUE_APP_IMG_API+dataMember[i].image.img_url : "default"
                })
            }
            customMenu.value = [...customMenu.value, {key: "devider"}, {icon: "UsersIcon",title: "สมาชิกในครัวเรือน",subMenu: member_menu}]
        }
    }
}
const breadcrumbComputed = computed(()=>{
    return [
    {
        name: "ครัวเรือน",
        path: "main-house-hold",
    },
    {
        name: "ข้อมูลครัวเรือน",
        path: "household-profile",
        param:{
          hhid: route.params.hhid,
          surveyid: route.params.surveyid
        }
    },
    {
        name: "ผลการตรวจสอบความถูกต้อง",
        active: true,
    }
]
})

onMounted(async ()=>{
    if(onlineComputed.value){
        await getSurvey()
        getCustomMenu()
    }
})

</script>

<style lang="scss">
</style>